import { DUMMY_DATA } from "../api/dummy-data";
import { ActionBar } from "./action-bar";
import { SEOTable } from "./table";

export const SEOManagement = () => {
  return (
    <div className="box">
      <ActionBar />
      <SEOTable data={DUMMY_DATA} />
    </div>
  );
};
